import _ from 'lodash';
import * as actionTypes from './actionTypes';
import { arrayMove } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export const axiosPayLoad = {
  errorMessages: {
    searchPage: [],
    detailPage: [],
    detailTab: [],
    bodyTab: [],
    headerTab: [],
  },
  filterData: {},
  templateType: [],
  planType: [],
  newpostdata:[],
  letterTemplateList: [],
  copyLetterTemplateList: [],
  fetchLetterTemplateDetail: [],
  letterTemplateDetail: {
    actionType: null,
    searchValue: {},
    detail: {},
  },
  letterTemplateDetailCopy: [],
  extraState: {
    fullScreenView: {
      templateTable: false,
      templateDetail: false,
      templateModal:false
    },
    edit: false,
    tabs: 'Details',
    deleteMF: [],
    createBtn: false,
    disableSave: false,
    coverErr: false,
    addDefHeader: false,
    addDefFooter: false,
    previewLoading: false,
  },
  previousTemplateVersion: [],
  allMergeFieldList: [],
  allMergeFieldListForDefaultFooter: [],
  coverMergeFieldList: [],
  collectMergeFieldList: [],
  disputeMergeFieldList: [],
  allSubMergeFieldList: [],
  saveMsg: [],
  manufacturerList: [],
  previewTemplate: [],
  allSelectedMergeField: [],
  windowAddrPos: [],
  tamplateListValidation: [],
  generalSystemParameter: [],
  autoSendIndValid: false,
  dramsInvStartQtr: null,
  pdfPreview: '',
  previewHeaderFooter: {},
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_LETTER_TEMPLATE_ERROR_MSG:
      return { ...state, errorMessages: action.errorMessages };
    case actionTypes.GET_REMOVE_LETTER_TEMPLATE_ERROR_MSG:
      return {
        ...state,
        errorMessages: { ...state.errorMessages, ...action.errorMessages },
      };
    case actionTypes.GET_REMOVE_LETTER_TEMPLATE_EXTRA_STATE:
      return {
        ...state,
        extraState: { ...state.extraState, ...action.extraState },
      };
    case actionTypes.GET_LETTER_TEMPLATE_FILTER_DATA:
      return { ...state, filterData: action.filterData };
    case actionTypes.GET_TEMPLATE_TYPE_LIST:
      var updatedArray = [];
      if (action.planType) {
        let localAr = action.planType;
        if (!_.isEmpty(localAr)) {
          localAr.forEach((element) => {
            if (element?.codeValueID?.codeValue === 'FD') {
              const indexOf = _.findIndex(localAr, element);

              if (!_.isNull(indexOf) && indexOf >= 0) {
                updatedArray = arrayMove(localAr, indexOf, 0);
              }
              localAr = updatedArray;
            }
          });
        }
      }
      return {
        ...state,
        templateType: action.templateType,
        planType: action.planType,
      };
    case actionTypes.GET_LETTER_TEMPLATE_LIST:
      return { ...state, letterTemplateList: action.letterTemplateList };
    case actionTypes.GET_COPY_LETTER_TEMPLATE_LIST:
      return {
        ...state,
        copyLetterTemplateList: action.copyLetterTemplateList,
      };
    case actionTypes.GET_LETTER_TEMPLATE_DETAIL_LIST:
      return { ...state, letterTemplateDetail: action.letterTemplateDetail };
    case actionTypes.FETCH_LETTER_TEMPLATE_DETAIL_LIST:
      return {
        ...state,
        fetchLetterTemplateDetail: action.fetchLetterTemplateDetail,
      };
    case actionTypes.GET_LETTER_TEMPLATE_DETAIL_COPY_LIST:
      return {
        ...state,
        letterTemplateDetailCopy: action.letterTemplateDetailCopy,
      };
    case actionTypes.GET_LETTER_TEMPLATE_EXTRA_STATE:
      return { ...state, extraState: action.extraState };
    case actionTypes.GET_LETTER_TEMPLATE_EXTRA_STATE_FROM_OTHER:
      return {
        ...state,
        extraState: { ...state.extraState, ...action.extraState },
      };
    case actionTypes.GET_PREVOIUS_TEMPLATE_VERSION_LIST_STATE:
      return {
        ...state,
        previousTemplateVersion: action.previousTemplateVersion,
      };
    case actionTypes.GET_ALL_MERGE_FIELD_LIST_STATE:
      return { ...state, allMergeFieldList: action.allMergeFieldList };
    case actionTypes.GET_ALL_MERGE_FIELD_LIST_FOR_DEFAULT_FOOTER_STATE:
      return {
        ...state,
        allMergeFieldListForDefaultFooter:
          action.allMergeFieldListForDefaultFooter,
      };
    case actionTypes.GET_ALL_SUB_MERGE_FIELD_LIST_STATE:
      return { ...state, allSubMergeFieldList: action.allSubMergeFieldList };
    case actionTypes.GET_LETTER_TEMPLATE_DETAIL_SAVE:
      return { ...state, saveMsg: action.saveMsg };
    case actionTypes.GET_MANUFACTURER_LIST:
      return { ...state, manufacturerList: action.manufacturerList };
    case actionTypes.GET_PREVIEW_TEMPLATE:
      return { ...state, previewTemplate: action.previewTemplate };
    case actionTypes.GET_ALL_SELECTED_MERGE_FIELD:
      return { ...state, allSelectedMergeField: action.allSelectedMergeField };
    case actionTypes.GET_COVER_MERGE_FIELD_LIST_STATE:
      return { ...state, coverMergeFieldList: action.coverMergeFieldList };
    case actionTypes.GET_COLLECT_MERGE_FIELD_LIST_STATE:
      return { ...state, collectMergeFieldList: action.collectMergeFieldList };
    case actionTypes.GET_DISPUTE_MERGE_FIELD_LIST_STATE:
      return { ...state, disputeMergeFieldList: action.disputeMergeFieldList };
    case actionTypes.GET_WINDOW_ADDRESS_POSITION_LIST:
      return { ...state, windowAddrPos: action.windowAddrPos };
    case actionTypes.GET_TEMPLATE_LIST_FOR_VALIDATION_CHECK:
      return {
        ...state,
        tamplateListValidation: action.tamplateListValidation,
      };
    case actionTypes.GET_PDF_PRINT_PREVIEW:
      return {
        ...state,
        pdfPreview: action.pdfPreview,
        extraState: { ...state.extraState, previewLoading: true },
      };
    case actionTypes.GET_PREVIEW_HEADER_FOOTER:
      return { ...state, previewHeaderFooter: action.previewHeaderFooter };
    case actionTypes.GET_GENERAL_SYSTEM_PARAMETER:
      return {
        ...state,
        generalSystemParameter: action.generalSystemParameter,
      };
    case actionTypes.AUTO_SEND_INDICATOR_VALIDATION:
      return {
        ...state,
        autoSendIndValid: action.autoSendIndValid,
      };
    case actionTypes.DRAMS_INVOICE_START_QTR:
      return {
        ...state,
        dramsInvStartQtr: action.dramsInvStartQtr,
      };
    case actionTypes.LETTER_TEMPLATE_CLEAR_REDUX_DATA:
      return action.payload ? action.payload : { ...axiosPayLoad };
    case actionTypes.GET_SENT_LETTER:
        return {
          ...state,
          newpostdata: action.payload,
        };
    default:
      return state;
  }
};

export default reducer;
